import axios from '@_system/axios/axios.js'
export default {
	path: '/pricefluctuations',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updatefromlist(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatefromlist/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updateprice(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/updateprice', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	relationgoods(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/relationgoods', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	adjust(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/adjust', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	export(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/pricefluctuations.pricefluctuations', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
